var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutleryAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.64286C7.5 2.28782 7.16421 2 6.75 2C6.33579 2 6 2.28782 6 2.64286V8C6 9.39786 6.95605 10.5724 8.24994 10.9055L8.24986 21.25C8.24986 21.6642 8.58564 22 8.99986 22C9.41407 22 9.74986 21.6642 9.74986 21.25L9.74994 10.9055C11.0439 10.5725 12 9.3979 12 8V2.64286C12 2.28782 11.6642 2 11.25 2C10.8358 2 10.5 2.28782 10.5 2.64286V8H9.74996L9.75 3.0002C9.75 2.58598 9.41422 2.25019 9.00001 2.25019C8.58579 2.25019 8.25 2.58597 8.25 3.00019L8.24996 8H7.5V2.64286Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3093 2C15.8027 2 15.3761 2.3788 15.3163 2.88182L14.0071 13.8818C13.9363 14.4768 14.401 15 15.0001 15H16.3993V21.25C16.3993 21.6642 16.7575 22 17.1994 22C17.6413 22 17.9995 21.6642 17.9995 21.25V14.0238C17.9997 14.0159 17.9998 14.0079 17.9998 14V3C17.9998 2.44772 17.5521 2 16.9998 2H16.3093Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutleryAlt);
export default __webpack_public_path__ + "static/media/cutlery-alt.c54e4a1585c3a0d90c091174fb5b09e4.svg";
export { ForwardRef as ReactComponent };